export const hr = {
  save: "Spremi",
  update: "Ažuriraj",
  accept: "Prihvati",
  cancel: "Odustani",
  close: "Zatvori",
  add: "Dodaj",
  check: "Provjeri",
  certificate: "Certifikat",
  certificates: "Certifikati",
  certification: "Certifikacija",
  certifications: "Certifikacije",
  "valid-certificate": "Važeći certifikat",
  date: "Datum",
  "valid-thru": "Vrijedi do",
  dashboard: "Početna stranica",
  error: "Stranica s pogreškom",
  forms: "Obrasci",
  notifications: "Obavijesti",
  "my-profile": "Moj profil",
  "my-documents": "Moji dokumenti",
  "no-documents-available": "Nema dostupnih dokumenata",
  "training-materials": "Materijali za obuku",
  "open-in-webviewer": "Otvori u pregledniku",
  expired: "Isteklo",
  "expired-training-materials": "Materijali za obuku kojima je istekao rok valjanosti",
  "register-headline": "Registracija",
  register: "Registriraj se",
  search: "Traži",
  print: "Ispiši",
  "printed-via": "Ispisano putem www.evalcard.com",
  settings: {
    label: "Postavke",
    publicProfile: {
      showEmailInPublic: "Prikaži adresu e-pošte",
      showPhoneInPublic: "Prikaži telefonski broj",
      showAddressInPublic: "Prikaži adresu",
    },
  },
  tables: "Tablice",
  tabs: "Kartice",
  myeval: "EvalCard",
  "eval-id": "Eval-ID",
  id: "ID",
  timeline: "Kronologija",
  typography: "Tipografija",
  admin: "Administrator",
  user: "Korisnik",
  templateAuthor: "Globalni autor predložaka",
  users: "Korisnici",
  "user-profile": "Korisnički profil",
  "company-name": "Naziv tvrtke",
  "company-logo": "Logotip tvrtke",
  "company-profile": "Profil tvrtke",
  "company-profile-admin": "Profil tvrtke",
  "company-invitation": "Poziv za pridruživanje tvrtki",
  "invitation-sent": "Poziv je poslan",
  "new-password": "Nova lozinka",
  "generate-new-password": "Generiraj novu lozinku",
  "current-password": "Trenutna lozinka",
  "repeat-password": "Ponovi lozinku",
  "password-successfully-changed": "Vaša lozinka je uspješno promijenjena",
  "password-reset": "Ponovno postavljanje lozinke",
  "edit-user-profile": "Uredi korisnički profil",
  "edit-user-profile-admin": "Uredi korisnički profil",
  system: "Sustav",
  widgets: "Widgeti",
  wizard: "Čarobnjak",
  logout: "Odjava",
  login: "Prijava",
  companies: "Tvrtke",
  "my-company": "Moja tvrtka",
  "leave-company": "Napusti tvrtku",
  "delete-company": "Izbriši tvrtku",
  company: "Tvrtka",
  uid: "PDV ID/porezni broj",
  employees: "Zaposlenici",
  employee: "Zaposlenik/ica",
  companyadmin: "Administrator",
  evalclient: "EVAL opunomoćenik",
  coworker: "Zaposlenici",
  "coworker-profile": "Profil zaposlenika",
  "search-user": "Traži korisnika",
  "search-user-placeholder": "Ime, e-pošta, EVAL-ID",
  trainer: "Trener",
  "training-level": "Razina obuke",
  gtp: "GTP",
  authorityAdmin: "Administrator",
  trainerRO: "Trener (samo čitanje)",
  authorityAdminRO: "Administrator (samo čitanje)",
  protocols: "Izvještaji o ispitivanju",
  report: "Izvještaj o ispitivanju",
  "new-report": "Novi izvještaj o ispitivanju",
  "all-reports": "Svi izvještaji o ispitivanju",
  "all-assets": "Svi objekti",
  "report-from": "Izvještaj o ispitivanju od",
  "report-details": "Detalji izvještaja o ispitivanju",
  data: "Podaci",
  info: "Informacije",
  attachment: "Prilog",
  contact: "Kontakt",
  continue: "Nastavi",
  start: "Pokreni",
  summary: "Sažetak",
  vin: "VIN",
  "licence-plate": "Registarska oznaka",
  owner: "Vlasnik",
  vehicles: "Vozila",
  vehicle: "Vozilo",
  "vehicle-details": "Detalji vozila",
  companyVehicle: "Vozilo tvrtke",
  valid: "U redu",
  invalid: "Nije u redu",
  tester: "Ispitivač",
  "vehicles-admin": "Vozila",
  "create-company-vehicle": "Dodaj vozilo",
  "select-vehicle": "Odaberi vozilo",
  "my-vehicles": "Moja vozila",
  "my-vehicle": "Moje vozilo",
  asset: "Objekt",
  assets: "Objekti",
  "serial-number": "Serijski broj",
  "asset-type": "Vrsta objekta",
  "asset-types": "Vrste objekata",
  "calibration-valid-thru": "Kalibracija vrijedi do",
  "requires-calibration": "Potrebna je redovita kalibracija",
  "calibration-warning-days": "Rok za upozorenje (dani)",
  "gtp-classes": "GTP klase",
  code: "Kod",
  subtype: "Podvrsta",
  icon: "Ikona",
  qualification: "Kvalifikacija (HTML)",
  gtpIcon: {
    car: "Automobil",
    forklift: "Viličar",
    gauge: "Tahometar",
    "train-front": "Vlak",
    ship: "Brod",
    plane: "Zrakoplov",
    settings: "Zupčanik",
    wrench: "Ključ za vijke",
  },
  photos: "Fotografije",
  "new-vehicle": "Novo vozilo",
  manufacturer: "Proizvođač",
  "no-manufacturer": "(Nema proizvođača)",
  "no-vehicle": "(Nema vozila)",
  "vehicle-manufacturer": "Proizvođač vozila",
  "create-vehicle": "Dodaj vozilo",
  "create-vehicle-manufacturer": "Dodaj proizvođača vozila",
  "construction-year": "Godina proizvodnje",
  "change-password": "Promijeni lozinku",
  roles: "Uloge",
  actions: "Radnje",
  action: "Radnja",
  profile: "Profil",
  email: "Adresa e-pošte",
  basic: "Osnovno",
  special: "Posebno",
  breakdown: "Raspodjela",
  "click-for-details": "Kliknite za detalje",
  rights: "Prava",
  details: "Detalji",
  information: "Informacije",
  "details-and-information": "Detalji i informacije",
  name: "Ime",
  namename: "Naziv",
  firstname: "Ime",
  lastname: "Prezime",
  fullname: "Ime i prezime",
  password: "Lozinka",
  street: "Ulica",
  number: "Broj",
  city: "Grad",
  country: "Država",
  "forgot-password": "Zaboravljena lozinka?",
  "recover-password": "Ponovno postavi lozinku",
  back: "Natrag",
  "back-to-login": "Natrag na prijavu",
  "go-to-login": "Na prijavu",
  "choose-picture": "Odaberi sliku",
  "choose-logo": "Odaberi logotip",
  "image-format-not-supported": "Ovaj format slike nije podržan. Odaberite JPG ili PNG sliku.",
  "send-invitation": "Pošalji poziv",
  zipcode: "Poštanski broj",
  previous: "Natrag",
  abort: "Odustani",
  "i-understand": "Razumijem",
  no: "Ne",
  yes: "Da",
  inputs: "Unosi",
  "user-activated": "Korisnik je aktiviran",
  "user-not-activated": "Korisnik još nije aktiviran",
  "user-did-not-receive-activation-email": "Korisnik još nije primio e-poštu za aktivaciju",
  "allow-coworkers-to-show-on-profile": "Prikaži na korisničkom profilu zaposlenika:",
  "resend-activation-email": "Ponovno pošalji poruku za aktivaciju",
  "coworker-education-status": "Status obuke zaposlenika",
  card: "Posjetnica",
  "certification-authority": "Certifikacijsko tijelo",
  "certification-authority-admin": "Certifikacijsko tijelo",
  "certification-authorities": "Certifikacijska tijela",
  "delete-certification-authority": "Izbriši certifikacijsko tijelo",
  "certificate-templates": "Predlošci certifikata",
  "certificate-template": "Predložak certifikata",
  "creating-certificates": "Certifikati se izrađuju...",
  "issue-certificate": "Izdaj certifikat",
  "issue-date": "Datum izdavanja",
  "due-date": "Datum isteka",
  "issued-on": "Izdano dana",
  "issued-by": "Izdao",
  author: "Izdavatelj",
  "certificate-name": "Naziv certifikata",
  "certificate-number": "Broj certifikata",
  "born-on": "rođen dana",
  mileage: "Kilometraža",
  public: "Javno",
  "back-to-the-app": "Natrag u aplikaciju",
  "can-create-reports": "Moguća je izrada izvještaja o ispitivanju",
  "temporary-certification": "Privremena certifikacija",
  "temporary-days-valid": "Vrijedi (dana)",
  "valid-for": "Vrijedi (godina)",
  "pdf-template": "PDF predložak",
  "pdf-certificate": "Vlastiti PDF certifikat",
  "show-pdf-certificate": "Prikaži certifikat u PDF-u",
  standards: "Standardi (HTML)",
  "text-block": "Tekst nakon standarda (HTML)",
  "text-block-hint": "Zamjenska polja: {placeholders} — qualifikationen umeće tekstove dodijeljenih GTP klasa",
  "digital-signature": "Digitalni potpis",
  eval0: "HV-0",
  eval1: "HV-1",
  eval2: "HV-2",
  eval3: "HV-3",
  eval4: "HV-4",
  evalc: "HV-C",
  evalbex: "HV-BEX",
  evall: "HV-L",
  evalf: "HV-F",
  evalpro: "HV-Pro",
  evals: "HV-S",
  evalt: "HV-T",
  sonstige: "Ostalo",
  others: "Drugo",
  levelGroupBase: "Osnovne razine",
  levelGroupSpecial: "Specijalizacija – zahtijeva prethodnu kvalifikaciju",
  levelGroupSpecialTraining: "Specijalističke obuke bez preduvjeta",
  level: "Razina",
  type: "Vrsta",
  "training-data": "Materijali za obuku",
  "training-info": "Informacije o obuci",
  "generated-password": "Generirana lozinka",
  "invitation-email": "E-pošta s pozivom",
  document: "Dokument",
  documents: "Dokumenti",
  active: "aktivno",
  inactive: "neaktivno",
  all: "SVE",
  "all-sort": "Sve/Sortiraj",
  "created-on": "Izrađeno dana",
  result: "Rezultat",
  results: "Rezultati",
  "try-again": "Pokušaj ponovno",
  status: "Status",
  published: "Objavljeno",
  draft: "Nacrt",
  sn: "SN",
  "something-went-wrong": "Nešto je pošlo po zlu",
  "checking-prerequisites": "Provjeravaju se uvjeti...",
  "prerequisite-warning-title": "Uvjeti koji nisu ispunjeni",
  "missing-prerequisites": "Potrebno je najmanje:",
  "info-signs": "Znakovi obavijesti",
  danger: "Pozor",
  "hazardous-voltage": "Opasan napon",
  "no-access-1": "Zabranjen pristup",
  "no-access-2": "neovlaštenim osobama",
  "access-only-by": "Pristup dopušten samo:",
  "company-logo-is-missing": "Nedostaje logotip tvrtke",
  download: "Preuzmi",
  "access-denied": "Pristup zabranjen",
  "dont-switch-on": "Ne uključivati",
  "hv-system": "HV sustav",
  disconnected: "Odvojen od napajanja",
  "disconnected-by": "Odvajanje od napajanja izvršio/la:",
  "works-in-progress": "Radovi u tijeku",
  forum: "EV forum",
  topic: "Tema",
  topics: "Teme",
  title: "Naslov",
  created: "Izrađeno",
  "created-by": "Izradio",
  "is-global": "Globalni predložak",
  "templateauthor-requires-report-permission": "Samo korisnici koji smiju izrađivati izvještaje mogu postati globalni autori predložaka.",
  from: "od",
  answers: "Odgovori",
  "post-answer": "Objavi odgovor",
  "edit-answer": "Uredi odgovor",
  "new-topic": "Nova tema",
  "edit-topic": "Uredi temu",
  "create-new-topic": "Izradi novu temu",
  "last-answer": "Posljednji odgovor",
  "view-all": "Prikaži sve",
  attachments: "Prilozi",
  "link-url": "Poveznica (URL)",
  "newest-topics": "Najnovije teme",
  "privacy-policy": "Pravila privatnosti",
  "new-files": "Nove datoteke",
  "existing-files": "Postojeće datoteke",
  courses: "Tečajevi",
  location: "Lokacija",
  loading: "Učitavanje…",
  "view-details": "Prikaži detalje",
  "no-courses-found": "Nije pronađen nijedan tečaj",
  "no-courses-assigned": "Nema dostupnih tečajeva",
  dialog: {
    "are-you-sure": "Jeste li sigurni?",
    "an-unexpected-error-occured": "Došlo je do neočekivane pogreške. Pokušajte ponovno kasnije",
    "do-you-really-want-the-user-to": "Želite li zaista korisnika",
    "do-you-really-want-the-invitation-to": "Želite li zaista poziv",
    delete: "izbrisati?",
    "delete-user": "Izbriši korisnika",
    "delete-topic": "Izbriši temu",
    "delete-topic-answer": "Izbriši odgovor",
    "remove-user": "Ukloni korisnika",
    "remove-trainer": "Ukloni ispitivača",
    "remove-from-company": "ukloniti iz tvrtke?",
    "remove-from-certification-authority": "ukloniti iz certifikacijskog tijela?",
    "create-user": "Dodaj korisnika",
    "the-most-important-information": "Najvažnije informacije",
    "create-company": "Izradi tvrtku",
    "the-most-important-information-about-the-company": "Najvažnije informacije o tvrtki",
    "create-company-vehicle": "Dodaj vozilo tvrtke",
    "the-most-important-information-about-the-vehicle": "Najvažnije informacije o vozilu",
    "the-most-important-information-about-the-asset": "Najvažnije informacije o objektu",
    "create-report": "Izradi izvještaj o ispitivanju",
    "where-is-the-company-located": "Gdje se nalazi tvrtka?",
    "where-is-the-certification-authority-located": "Gdje se nalazi certifikacijsko tijelo?",
    "whats-the-role-of-the-person": "Koju funkciju ima osoba?",
    "where-does-the-person-live": "Gdje osoba stanuje?",
    "further-details": "Dodatne pojedinosti",
    "register-successfull": "Registracija je uspješna! Uskoro ćete primiti poruku e-pošte sa svojom lozinkom.",
    "great-you-will-receive-an-email": "Uskoro ćete primiti poruku e-pošte s poveznicom za ponovno postavljanje lozinke.",
    "this-should-not-take-longer-than": "To ne bi trebalo trajati duže od 5 minuta. Ako ipak potraje, provjerite i mapu za neželjenu poštu.",
    "i-agree": "Slažem se s",
    "terms-and-conditions": "Općim uvjetima poslovanja",
    "hereby-i-agree": "Ovime se slažem da EvalCert GmbH smije koristiti moje osobne podatke u svrhu izdavanja EVAL kartice i registracije korisnika na my.evalcard.com.",
    "further-i-agree-to": "Nadalje pristajem da me EvalCert GmbH do opoziva privole putem biltena e-poštom obavještava o novostima u području visokog napona (novim obukama, proizvodima ili događanjima).",
    "allowed-to-be-used": " (.de odnosno .com) smije se koristiti.",
    "refusal-is-allways": "Privolu možete opozvati u bilo kojem trenutku slanjem poruke e-pošte na",
    possible: ".",
    "the-e-val-card-is-the": "EVAL kartica je dokaz kvalifikacije u formatu bankovne kartice. Skraćenica EVAL znači Electric Vehicle Access License",
    "complete-user-data": "Dopunite korisničke podatke",
    "complete-user-data-info": "Kako bismo vam mogli pružiti odgovarajuću podršku i omogućiti korištenje svih funkcija, vaš korisnički profil mora biti potpuno ispunjen.",
    "your-password-reset-is-being-processed": "Ponovno postavljanje vaše lozinke je u tijeku. Ako to potraje dulje od nekoliko minuta, pokušajte ponovno.",
    "your-password-has-been-sent": "Vaša je lozinka uspješno ponovno postavljena. U roku od nekoliko minuta trebali biste primiti poruku e-pošte s novom lozinkom.",
    "if-it-did-not-work": "Provjerite i mapu neželjene pošte. Ako poruka ne stigne u roku od nekoliko minuta, pokušajte ponovno.",
    "user-not-authorized": "Adresa e-pošte ili lozinka nije ispravna",
    "user-not-activated": "Ovaj korisnik još nije aktiviran. Upotrijebite poveznicu iz poruke e-pošte za aktivaciju.",
    "user-or-password-wrong": "Adresa e-pošte ili lozinka nije ispravna",
    "users-selected": "Odabrani korisnici",
    "user-profile-update-successfull": "Korisnički profil je uspješno spremljen",
    "user-profile-update-failed": "Korisnički profil nije bilo moguće spremiti. Pokušajte ponovno kasnije.",
    "do-you-really-want-to-leave-the-company": "Želite li zaista napustiti tvrtku?",
    "in-order-to-accept-a-company-invitation": "Da biste prihvatili poziv za pridruživanje tvrtki, morate biti registrirani i prijavljeni.",
    "do-you-really-want-to-join-the-company": "Jeste li sigurni da se želite pridružiti tvrtki?",
    "if-you-are-already-in-a-company-you-will-be-removed": "Ako ste već član neke tvrtke, bit ćete uklonjeni iz nje.",
    "you-are-not-a-member-of-a-company": "Trenutačno niste član nijedne tvrtke. Ovu stranicu možete koristiti čim postanete član tvrtke.",
    "you-are-not-a-member-of-a-certification-authority": "Trenutačno niste član nijednog certifikacijskog tijela",
    "do-you-really-want-the-company-to": "Želite li zaista tvrtku",
    "company-created-successfully": "Tvrtka je uspješno izrađena",
    "company-already-exists": "Tvrtka s ovim nazivom ili ovom adresom e-pošte već postoji. Zato je nije moguće izraditi.",
    "vehicle-save-successfully": "Vozilo je uspješno spremljeno",
    "asset-save-successfully": "Objekt je uspješno spremljen",
    "gtp-class-save-successfully": "GTP klasa je uspješno spremljena",
    "gtp-class-already-exists": "GTP klasa s ovim kodom već postoji",
    "do-you-really-want-the-gtp-class-to": "Želite li zaista GTP klasu",
    "asset-type-save-successfully": "Vrsta objekta je uspješno spremljena",
    "do-you-really-want-the-asset-type-to": "Želite li zaista vrstu objekta",
    "vehicle-already-exists": "Vozilo s ovim VIN-om i vlasnikom već postoji",
    "vehicle-accepted": "Vozilo je preuzeto u sustav",
    "vehicle-manufacturer-accepted": "Proizvođač vozila je preuzet u sustav",
    "report-save-successfully": "Izvještaj o ispitivanju je uspješno spremljen",
    "report-already-exists": "Izvještaj o ispitivanju s ovim nazivom ili ove vrste već postoji u ovoj tvrtki.",
    "create-company-failed": "Tvrtku nije bilo moguće izraditi. Pokušajte ponovno kasnije.",
    "save-user-success": "Korisnik je uspješno spremljen",
    "user-already-exists": "Korisnik s ovom adresom e-pošte ili ovim imenom već postoji.",
    "save-company-success": "Tvrtka je uspješno spremljena",
    "save-company-failed": "Tvrtku nije bilo moguće spremiti. Pokušajte ponovno kasnije.",
    "save-changes-success": "Promjene su uspješno spremljene",
    "do-you-really-want-the-vehicle-to": "Želite li zaista vozilo",
    "do-you-really-want-the-asset-to": "Želite li zaista objekt",
    "do-you-really-want-the-report-to": "Želite li zaista izvještaj o ispitivanju",
    "do-you-really-want-the-certificate-to": "Želite li zaista certifikat",
    "do-you-really-want-the-vehicle-manufacturer-to": "Želite li zaista proizvođača vozila",
    "save-vehicle-manufacturer-success": "Proizvođač vozila je uspješno spremljen",
    "save-vehicle-manufacturer-error": "Proizvođača vozila nije bilo moguće spremiti. Pokušajte ponovno kasnije.",
    "save-vehicle-success": "Vozilo je uspješno spremljeno",
    "save-vehicle-error": "Vozilo nije bilo moguće spremiti",
    "who-works-in-the-company": "Tko radi u tvrtki?",
    "who-works-in-the-certification-authority": "Tko radi u certifikacijskom tijelu?",
    "your-company-has-been-created-check-your-emails": "Vaša je tvrtka izrađena! Uskoro biste trebali primiti poruku e-pošte s poveznicom za aktivaciju tvrtke. Provjerite i mapu neželjene pošte.",
    "if-you-havent-received-an-email-yet": "Ako još niste primili poruku e-pošte, ovdje možete zatražiti ponovno slanje.",
    "if-this-did-not-work": "Ako ni to nije uspjelo, možete napustiti svoju tvrtku i izraditi novu.",
    "is-already-in-a-company": "je već član neke tvrtke",
    "invite-user-already-exists-in-company": "Korisnik s ovom adresom e-pošte već je član tvrtke.",
    "invite-user-already-exists-in-other-company": "Korisnik s ovom adresom e-pošte već je član druge tvrtke.",
    "create-certification-authority": "Dodaj certifikacijsko tijelo",
    "certification-authority-save-successfully": "Certifikacijsko tijelo je uspješno spremljeno",
    "certification-authority-already-exists": "Certifikacijsko tijelo s ovom adresom e-pošte ili ovim nazivom već postoji.",
    "certificate-already-exists": "Certifikacija s ovim nazivom već postoji za ovog korisnika.",
    "certificate-save-successfully": "Certifikacija je uspješno spremljena",
    "do-you-really-want-to-delete": "Želite li zaista izbrisati",
    "delete-report-template": "Izbriši predložak kontrolne liste",
    "create-certificate": "Izradi certifikat",
    "create-certificate-template": "Izradi predložak certifikata",
    "who-gets-the-certificate": "Kome se certifikat izdaje",
    "user-with-this-eval-id-was-not-found": "Korisnik s ovim Eval-ID-om nije pronađen",
    "you-can-only-add-reports-if-you-have-company-vehicles": "Izvještaj možete izraditi samo ako posjedujete vozila tvrtke",
    "you-can-only-input-eu-numbers": "Mogući su samo brojevi u EU formatu",
    "you-dont-have-the-rights": "Nemate ovlasti za korištenje ove funkcije",
    "certificate-template-save-success": "Predložak certifikata je uspješno spremljen",
    "certificate-template-sort-save-success": "Redoslijed predložaka certifikata uspješno je spremljen",
    "your-certification-authority-does-not-have-templates": "Najprije izradite predložak certifikata kako biste mogli izdavati certifikate",
    "this-company-is-not-yet-activated": "Ova tvrtka još nije aktivirana. Poveznica za aktivaciju poslana je na adresu e-pošte tvrtke.",
    "welcome-to-the-dashboard": "Dobro došli na početnu stranicu! Trenutačno niste član nijedne tvrtke. Kada postanete član tvrtke, ovdje ćete vidjeti pregled svojih izvještaja o ispitivanju.",
    "valid-certificates": "Važeći certifikati",
    "certificates-last-30-days": "Certifikati – posljednjih 30 dana",
    "certificates-on": "Certifikati dana",
    "reports-last-30-days": "Izvještaji – posljednjih 30 dana",
    "no-data-available": "Podaci još nisu dostupni",
    "this-manufacturer-does-not-exist": "Ovaj proizvođač još nije u sustavu. Automatski će biti dodan za vas.",
    "this-vehicle-does-not-exist": "Ovo vozilo još nije u sustavu. Automatski će biti dodano za vas.",
    "required-to-complete-registration": "Za dovršetak registracije potrebna je privola",
    "email-is-already-used": "Ova adresa e-pošte već se koristi",
    "enter-valid-birthday-date": "Unesite ispravan datum rođenja",
    "enter-valid-eu-number-format": "Koristite samo brojeve u EU formatu",
    "only-use-numbers-with-or": "Koristite samo brojeve i '-' ili '/'",
    "this-user-is-already-in-this-certification-authority": "Ovaj korisnik je već u ovom certifikacijskom tijelu",
    "this-user-is-already-selected": "Ovaj korisnik je već odabran",
    "this-user-is-already-in-a-company": "Ovaj je korisnik već član neke tvrtke",
    "the-document-could-not-be-loaded": "Dokument nije bilo moguće učitati",
    continue: "Nastavi",
    finish: "Gotovo",
    "cannot-add-users": "Nije moguće dodati sljedeće korisnike zbog sukoba podataka:",
    "add-course": "Dodaj tečaj",
    "course-created-successfully": "Tečaj je uspješno izrađen.",
    "course-updated-successfully": "Tečaj je uspješno ažuriran.",
    "mark-course-as-free": "Označi tečaj kao besplatan",
    "scan-qr-code": "Skeniraj QR kod",
    "scan-to-join-course": "Skenirajte QR kod za prijavu na tečaj",
    "remove-participant": "Ukloni polaznika",
    "remove-participant-description": "Želite li ukloniti ovog polaznika s tečaja?",
    "user-is-already-participant": "Ovaj je korisnik već polaznik tečaja",
    "user-already-selected": "Korisnik je već odabran",
    "delete-course": "Izbriši tečaj",
    "delete-course-description": "Ovaj će tečaj biti izbrisan, a svi polaznici uklonjeni. Želite li nastaviti?",
    "course-removed": "Tečaj je uklonjen",
    "remove-efk-success": "Korisniku je uspješno uklonjen status ESP.",
    "create-checklist": "Izradi kontrolnu listu",
    "make-efk-success": "Status ESP uspješno je dodijeljen, a korisnik je obaviješten.",
    "resend-efk-success": "Poziv za dodjelu statusa ESP ponovno je poslan",
    "participants-added-successfully": "Polaznici su uspješno dodani",
    "delete-document": "Izbriši dokument",
    "delete-document-description": "Želite li zaista izbrisati ovaj dokument?",
    "delete-certificate-template": "Izbriši predložak certifikata",
    "do-you-really-want-the-certificate-template-to": "Želite li zaista predložak certifikata",
    "do-you-really-want-the-certification-authority-to": "Želite li zaista certifikacijsko tijelo",
    "delete-task": "Izbriši zadatak",
    "do-you-really-want-to-delete-the-task": "Želite li zaista izbrisati zadatak „{name}“?",
    "delete-section": "Izbriši odjeljak",
    "do-you-really-want-to-delete-the-section": "Želite li zaista izbrisati odjeljak „{name}“?",
    "course-content-saved-successfully": "Sadržaj tečaja uspješno je spremljen",
    "remove-certification-authority": "Ukloni certifikacijsko tijelo",
    "do-you-really-want-to-remove-certification-authority": "Želite li zaista ukloniti certifikacijsko tijelo „{name}“?",
    "remove-course-content": "Ukloni sadržaj tečaja",
    "do-you-really-want-to-remove-course-content": "Želite li zaista ukloniti sadržaj tečaja „{name}“?",
    "successfully-removed-course-content": "Sadržaj tečaja je uspješno uklonjen",
    "language-already-exists-in-course": "Odabrani jezik već postoji u ovom tečaju",
    "do-you-really-want-to-remove-course": "Želite li zaista ukloniti tečaj „{name}“?",
    "successfully-removed-course": "Tečaj je uspješno uklonjen",
    "publish-course-warning": "Jeste li sigurni da želite objaviti „{name}“? Nakon objave tečaj se više ne može uređivati dok se objava ne povuče.",
    "unpublish-course-confirmation": "Jeste li sigurni da želite povući objavu tečaja „{name}“? Nakon toga ponovno će biti moguće uređivanje.",
    "course-published-successfully": "Tečaj je uspješno objavljen",
    "course-unpublished-successfully": "Objava tečaja je uspješno povučena",
    "successfully-enrolled-course": "Uspješno ste se upisali na tečaj",
    "remove-enrollment": "Ukloni upis",
    "do-you-really-want-to-remove-enrollment": "Želite li zaista ukloniti ovaj upis?",
    "successfully-removed-enrollment": "Upis je uspješno uklonjen",
  },
  tooltip: {
    "csv-export": "Izvoz u CSV",
    "add-user": "Dodaj korisnika",
    "invite-user": "Pozovi korisnika",
    "delete-user": "Izbriši korisnika",
    "remove-user": "Ukloni korisnika",
    "edit-user": "Uredi korisnika",
    "view-user": "Prikaži korisnika",
    "send-invitation-again": "Pošalji poziv ponovno",
    "send-activation-again": "Ponovno pošalji poveznicu za aktivaciju",
    "admin-cant-leave-company": "Kao EVAL opunomoćenik ne možete napustiti tvrtku",
    "leave-company": "Napusti tvrtku",
    "add-company": "Dodaj tvrtku",
    "edit-company": "Uredi tvrtku",
    "delete-company": "Izbriši tvrtku",
    "add-selected-users-to-company": "Dodaj odabrane korisnike u tvrtku",
    "add-selected-users-to-course": "Dodaj odabrane korisnike na tečaj",
    "add-vehicle": "Dodaj vozilo",
    "show-vehicle": "Detalji vozila",
    "edit-vehicle": "Uredi vozilo",
    "view-vehicle": "Prikaži vozilo",
    "accept-vehicle": "Preuzmi vozilo u sustav",
    "accept-vehicle-manufacturer": "Preuzmi proizvođača vozila u sustav",
    "delete-vehicle": "Izbriši vozilo",
    "add-asset": "Dodaj objekt",
    "add-gtp-class": "Dodaj GTP klasu",
    "edit-gtp-class": "Uredi GTP klasu",
    "delete-gtp-class": "Izbriši GTP klasu",
    "add-asset-type": "Dodaj vrstu objekta",
    "edit-asset-type": "Uredi vrstu objekta",
    "delete-asset-type": "Izbriši vrstu objekta",
    "show-asset": "Detalji objekta",
    "edit-asset": "Uredi objekt",
    "delete-asset": "Izbriši objekt",
    "add-vehicle-manufacturer": "Dodaj proizvođača vozila",
    "edit-vehicle-manufacturer": "Uredi proizvođača vozila",
    "delete-vehicle-manufacturer": "Izbriši proizvođača vozila",
    "vehicle-details-missing": "Nedostaju detalji vozila",
    "remove-invitation": "Ukloni poziv",
    "send-missing-activations": "Pošalji nedostajuće poruke e-pošte za aktivaciju",
    "show-password": "Prikaži lozinku",
    "hide-password": "Sakrij lozinku",
    "create-report": "Izradi izvještaj o ispitivanju",
    "select-for-report": "Odaberi za izvještaj o ispitivanju",
    "add-question": "Dodaj pitanje",
    "remove-question": "Ukloni pitanje",
    "create-certificates": "Izradi certifikate",
    "view-certificate": "Prikaži certifikat",
    "delete-certificate": "Izbriši certifikat",
    "view-report": "Prikaži izvještaj o ispitivanju",
    "delete-report": "Izbriši izvještaj o ispitivanju",
    "no-pdf-found": "PDF dokument nije pronađen",
    "add-report": "Dodaj izvještaj o ispitivanju",
    "add-certificate": "Dodaj certifikat",
    "no-certificate-to-create-report": "Nemate odgovarajući certifikat za izradu izvještaja o ispitivanju",
    "add-certification-authority": "Dodaj certifikacijsko tijelo",
    "edit-certification-authority": "Uredi certifikacijsko tijelo",
    "delete-certification-authority": "Izbriši certifikacijsko tijelo",
    "add-certificate-template": "Dodaj predložak certifikata",
    "edit-certificate-template": "Uredi predložak certifikata",
    "delete-certificate-template": "Izbriši predložak certifikata",
    "add-report-template": "Dodaj predložak izvještaja",
    "edit-report-template": "Uredi predložak izvještaja",
    "delete-report-template": "Izbriši predložak izvještaja",
    "view-certificate-training-data": "Prikaži materijale za obuku",
    "save-sorting": "Spremi redoslijed",
    "mark-user": "Označi korisnika za izvoz u CSV",
    "open-topic": "Prikaži temu",
    "edit-topic": "Uredi temu",
    "delete-topic": "Izbriši temu",
    "edit-topic-answer": "Uredi odgovor",
    "delete-topic-answer": "Izbriši odgovor",
    "select-all-users": "Označi sve trenutačne korisnike za izvoz u CSV",
    "add-course": "Dodaj tečaj",
    "show-qr": "Prikaži QR kod",
    "edit-course": "Uredi tečaj",
    "publish-course": "Objavi tečaj",
    "unpublish-course": "Povuci objavu tečaja",
    "remove-course": "Izbriši tečaj",
    "view-course": "Prikaži tečaj",
    "remove-efk": "Ukloni status ESP",
    "see-more": "Prikaži više",
  },
  phone: "Telefonski broj",
  address: "Adresa",
  birthday: "Datum rođenja",
  "profile-picture": "Profilna slika",
  userprofile: {
    "edit-profile": "Uredi profil",
    "public-profile": "Javni profil",
    "following-information": "Sljedeće informacije prikazuju se na Vašem javnom profilu",
    "notification-settings": "Ako Vaša tvrtka ne šalje obavijesti, ova postavka nema učinka.",
  },
  "training-director": "Voditelj obuke",
  "participated-the-training": "je na obuci ",
  "result-protocol": "Zapisnik o rezultatima",
  measurements: "Mjerne vrijednosti",
  freischaltung: "Odvajanje od napajanja",
  isolationswiderstand: "Izolacijski otpor",
  potentialausgleich: "Izjednačavanje potencijala",
  r: {
    "measuring-instrument-functionality": "Ispravnost mjernog instrumenta",
    "positive-test-done": "Provedena provjera ispravnosti mjernog instrumenta",
    "voltage-between-hv-plus-and-chassis": "Napon između HV+ i šasije",
    "voltage-between-hv-plus-and-hv-minus": "Napon između HV+ i HV−",
    "voltage-between-hv-minus-and-chassis": "Napon između HV− i šasije",
    "the-tester-accepts-the-security-instructions": "Ispitivač potvrđuje poštivanje sigurnosnih uputa proizvođača",
    "measuring-instrument-tested-at-reference-source": "Je li ispravnost mjernog instrumenta provjerena na referentnom izvoru?",
    "measuring-instrument-tested": "Je li provjerena ispravnost mjernog instrumenta?",
    "absence-of-voltage": "Beznaponsko stanje",
    "absence-of-voltage-confirmed": "Utvrđeno beznaponsko stanje",
    voltage: "Napon (V)",
    "used-voltage": "Korišteni napon",
    "used-test-voltage": "Primijenjeni ispitni napon",
    "isolation-standard": "Zadana vrijednost izolacijskog otpora",
    "resistance-per-volt": "Otpor po voltu",
    "hv-system-voltage": "Napon HV sustava",
    "isolation-resistance-between-hv-plus-and-chassis": "Izolacijski otpor između HV+ i šasije",
    "isolation-resistance-between-hv-minus-and-chassis": "Izolacijski otpor između HV− i šasije",
    "further-measurements-if-needed": "Dodatna mjerenja prema potrebi",
    "test-current": "Ispitna struja (A)",
    "test-current-q": "Ispitna struja ...",
    "measuring-point": "Mjerna točka",
    "measuring-point-chassis-vs": "Mjerenje između šasije i …",
    "converter-housing": "Kućište invertera",
    "further-voltage-measurements-if-needed": "Dodatna mjerenja napona prema potrebi",
    "measurements-ok-if-smaller-than-1-v": "Rezultat mjerenja je zadovoljavajući ako je izmjereni napon manji od 1 V",
    "visual-inspection": "Vizualni pregled",
    "cable-visual-inspection": "Je li provjereno ima li kabel vidljivih oštećenja?",
    "connector-visual-inspection": "Je li provjereno ima li konektor vidljivih oštećenja?",
    "isolation-test": "Ispitivanje izolacije",
    "cable-isolation-test": "Je li provjeren izolacijski otpor kabela?",
    "function-test": "Funkcionalno ispitivanje",
    "cable-function-test": "Je li postupak punjenja uspješno ispitan?",
    "charging-cable-inspection-notes": "Dodatna ispitivanja ako je potrebno",
  },
  "new-report-no-id": "Novi izvještaj o ispitivanju",
  "required-field": "Ovo polje je obavezno.",
  "fill-out-all-required-fields": "Ispunite sva obavezna polja!",
  "valid-email-only": "Unesite ispravnu adresu e-pošte.",
  "max-characters": "Najviše {count} znakova",
  "certificate-notification": "Obavijesti o certifikatima",
  "certificate-notification-company": "Time se mogu deaktivirati obavijesti za sve zaposlenike.",
  "calibration-notification": "Obavijesti o kalibraciji",
  "calibration-notification-company": "Podsjetnik prije isteka valjanosti kalibracije objekta.",
  "haynes-pro-vehicle-details": "Podaci o vozilu iz sustava HaynesPro",
  "haynes-pro-no-details": "Za odabrano vozilo nisu dostupni dodatni podaci.",
  "haynes-pro-hv-disconnect": "Visokonaponski sustav: uspostavljanje beznaponskog stanja",
  "vehicle-details-admin": "Detalji vozila",
  "haynes-pro-details": "Podaci iz sustava HaynesPro",
  "haynes-pro-details-admin": "Podaci iz sustava HaynesPro",
  "haynes-pro-details-not-found": "Nažalost, za ovo vozilo nije ništa pronađeno.",
  "haynes-pro-load-error": "Upute nije bilo moguće učitati.",
  retry: "Pokušaj ponovno",
  "haynes-pro-details-more-than-one-story": "Pronađeno je više priručnika:",
  participants: "Polaznici",
  "join-course": "Prijavi se na tečaj",
  "join-course-description": "Želite li se prijaviti na tečaj? Trener će tada moći upravljati vašim podacima kao polaznika tečaja.",
  "course-id-required": "Za prijavu na tečaj potreban je ID tečaja!",
  "course-not-found": "Tečaj nije pronađen",
  "error-loading-course": "Pogreška pri učitavanju tečaja",
  "successfully-joined-course": "Uspješno ste se prijavili na tečaj",
  "error-joining-course": "Pogreška pri prijavi na tečaj. Obratite se svom treneru.",
  refresh: "Ponovno učitaj",
  "edit-course": "Uredi tečaj",
  "make-efk": "Imenuj za ESP",
  "make-efk-description": "Želite li imenovati ovog korisnika za ESP? Korisnik mora potvrditi imenovanje.",
  "resend-efk-invitation": "Ponovno pošalji poziv za imenovanje za ESP",
  "cancel-efk": "Otkaži imenovanje za ESP",
  efk: "ESP",
  "efk-position": "Pozicija ESP (stručna električarska osoba)",
  "do-you-want-to-accept-efk-position": "Želite li prihvatiti poziciju ESP (stručna električarska osoba)?",
  "do-you-want-to-refuse-efk-position": "Želite li odbiti poziciju ESP (stručna električarska osoba)?",
  refuse: "Odbij",
  "in-order-to-handle-efk-position": "Da biste mogli odgovoriti na poziv za imenovanje za ESP, morate se prijaviti ili najprije registrirati.",
  "efk-position-accepted": "Pozicija ESP (stručna električarska osoba) je prihvaćena",
  "efk-position-refused": "Pozicija ESP (stručna električarska osoba) je odbijena",
  pending: "Na čekanju",
  "remove-efk-description": "Želite li zaista ovom korisniku ukloniti status ESP?",
  "cancel-efk-description": "Želite li zaista otkazati poziv za imenovanje ovog korisnika za ESP?",
  aborted: "Odbijeno",
  checklists: "Kontrolne liste",
  "all-checklists": "Sve kontrolne liste",
  manage: "Upravljanje",
  "global-templates": "Globalni predlošci",
  "global-template-authors": "Globalni autori predložaka",
  "add-global-template-author": "Dodaj globalnog autora predložaka",
  "remove-global-template-author-confirm": "Želite li ovom korisniku ukloniti ulogu globalnog autora predložaka?",
  "report-templates": "Predlošci izvještaja",
  "report-template": "Predložak izvještaja",
  "create-report-template": "Izradi predložak izvještaja",
  "edit-report-template": "Uredi predložak izvještaja",
  "delete-report-template": "Izbriši predložak izvještaja",
  checklist: "Kontrolna lista",
  form: "Izvještaj o ispitivanju vozila",
  "basic-information": "Osnovne informacije",
  "object-data": "Podaci o objektu",
  "object-data-configuration": "Konfiguracija podataka o objektu",
  "object-data-config-description": "Konfigurirajte prilagođena polja za prikupljanje podataka kada vozilo nije obavezno.",
  "requires-vehicle": "Vozilo je obavezno",
  "assigned-vehicles": "Dodijeljena vozila",
  "assigned-vehicles-hint": "Prazno = vrijedi za sva vozila",
  "assigned-vehicles-no-data": "Traži vozilo …",
  "available-reports": "Dostupni izvještaji",
  "create-report-now": "Izradi izvještaj",
  "vehicle-added-to-fleet": "Vozilo je dodano među vozila vaše tvrtke.",
  "requires-asset": "Objekt je obavezan",
  "select-asset": "Odaberi objekt",
  "field-name": "Naziv polja",
  "display-name": "Prikazani naziv",
  "add-field": "Dodaj polje",
  "questions-description": "Konfigurirajte pitanja za ovaj predložak",
  "add-question": "Dodaj pitanje",
  "example-images": "Ogledne slike",
  "upload-example-images": "Učitaj ogledne slike",
  "remove-image": "Ukloni sliku",
  "images-uploaded-successfully": "Slike su uspješno učitane",
  "error-uploading-images": "Pogreška pri učitavanju slika",
  "enable-validation": "Aktiviraj validaciju",
  "validation-configuration": "Konfiguracija validacije",
  "expected-value": "Očekivana vrijednost",
  "at-least-one-language-required": "Potreban je najmanje jedan jezik",
  "language-not-available": "Ovaj jezik ne postoji",
  "multilingual-fields-info": "Višejezična polja: unesite samo jezike za koje imate prijevode. Najmanje jedan jezik je potreban za nazive i pitanja.",
  operator: "Operator",
  "validation-value": "Vrijednost validacije",
  equal: "Jednako",
  "less-than": "Manje od",
  "greater-than": "Veće od",
  "form-vehicle-info": "Ovo je predložak obrasca. Obrasci se koriste kada je za izvještaj potrebno vozilo.",
  "checklist-object-data-info": "Ovo je predložak kontrolne liste. Kontrolne liste koriste konfiguraciju podataka o objektu umjesto vozila.",
  "protocols-title": "Izvještaji",
  "evalus-reports": "Opći predlošci",
  "company-reports": "Izvještaji tvrtke",
  "custom-templates": "Prilagođeni predlošci",
  description: "Opis",
  questions: "Pitanja za provjeru",
  question: "Pitanje",
  unit: "Jedinica",
  boolean: "Da/Ne",
  text: "Tekst",
  "question-type-number": "Broj",
  dropdown: "Padajući popis",
  options: "Opcije",
  option: "Opcija",
  "add-option": "Dodaj opciju",
  "expected-option": "Očekivana opcija",
  "dropdown-options-required": "Svako pitanje s padajućim popisom mora sadržavati barem jednu popunjenu opciju",
  "no-questions-yet": "Još nema pitanja — dodaj prvo",
  "no-fields-yet": "Još nema polja — dodaj prvo",
  "question-incomplete": "Ovo pitanje je još nepotpuno",
  "is-active": "Aktivno",
  "add-checklist": "Dodaj kontrolnu listu",
  "select-checklist-template": "Odaberite predložak kontrolne liste",
  "no-checklist-templates-available": "Nema dostupnih predložaka kontrolnih lista.",
  template: "Predložak",
  "checklist-object-data": "Podaci izvještaja",
  "report-template-saved": "Predložak izvještaja je uspješno spremljen",
  "new-checklist": "Nova kontrolna lista",
  "view-checklist": "Prikaži kontrolnu listu",
  "checklist-from": "Kontrolna lista od",
  "checklist-details": "Detalji kontrolne liste",
  field: "Polje",
  "checklist-created-successfully": "Kontrolna lista je uspješno izrađena",
  "error-creating-checklist": "Pogreška pri izradi kontrolne liste. Pokušajte ponovno kasnije.",
  "tested-with-object": "S objektom",
  "required-asset-type": "Potrebna vrsta objekta",
  "required-asset-type-hint": "Vrsta objekta koji se mora koristiti pri ovom ispitivanju vozila. Ostavite prazno ako objekt nije potreban.",
  "can-calibrate": "Može kalibrirati objekte",
  "calibratable-asset-type": "Vrsta objekta koja se može kalibrirati",
  "calibratable-asset-type-hint": "Samo objekti ove vrste mogu se kalibrirati ovom kontrolnom listom.",
  "calibration-validity-months": "Valjanost kalibracije (mjeseci)",
  "calibration-validity-months-hint": "Ako se ova kontrolna lista dovrši bez pogrešaka, objekt se toliko mjeseci ponovno smatra kalibriranim.",
  "select-required-asset": "Korišteni objekt",
  "asset-locked-calibration-expired": "Blokirano – valjanost kalibracije istekla je prije više od {days} dana ({date})",
  "asset-calibration-expired-on": "Valjanost kalibracije istekla je dana {date}",
  "asset-restricted-hint": "Ovo ispitivanje smije se provesti samo s objektom vrste „{type}“.",
  "asset-none-of-required-type": "Vaša tvrtka nema objekt vrste „{type}“. Najprije dodajte odgovarajući objekt kako biste mogli provesti ovo ispitivanje.",
  "asset-all-expired": "Valjanost kalibracije svih odgovarajućih objekata istekla je prije više od {days} dana pa su objekti blokirani. Za nastavak ažurirajte datum kalibracije u podacima objekta.",
  "asset-no-longer-allowed": "Odabrani objekt više nije dopušten za ovo ispitivanje – možda je u međuvremenu prošlo previše vremena od isteka valjanosti njegove kalibracije. Provjerite odabir.",
  "add-users-to-course": "Dodaj korisnike na tečaj",
  "selected-users": "Odabrani korisnici",
  "start-date": "Datum početka",
  "end-date": "Datum završetka",
  "evalus-reports-info": "Ovdje se nalaze „Opći predlošci“. Posebne izvještaje možete pronaći, izraditi i uređivati u izborniku „Kontrolne liste“.",
  role: "Uloga",
  eup: "EUP",
  "efk-tooltip": "Stručna električarska osoba",
  "eup-tooltip": "Elektrotehnički upućena osoba",
  "efk-pending": "Poziv na čekanju",
  "strictly-required": "Obavezno",
  "strictly-required-info": "Ako je aktivirano, izvještaj se ne može poslati ako ova validacija ne uspije",
  "validation-failed": "Obavezna provjera valjanosti nije zadovoljena",
  "cannot-submit-invalid-required": "Nije moguće poslati: obavezna provjera valjanosti nije zadovoljena",
  "create-new-entry": "Izradi novi unos",
  "trainer-invalid-certificate": "Trener više nema važeći HV-4 ili HV-L certifikat.",
  to: "do",
  "date-filter": "Filtar datuma",
  "clear-filter": "Očisti filtar",
  "oldest-first": "Najstarije prvo",
  "newest-first": "Najnovije prvo",
  "course-documents": "Dokumenti tečaja",
  "select-documents": "Odaberi dokumente",
  "upload-documents": "Učitaj dokumente",
  uploading: "Učitavanje…",
  "drag-and-drop-files": "Povucite datoteke ovamo i otpustite ih",
  "drop-files-here": "Otpustite datoteke ovdje",
  "or-click-to-browse": "ili kliknite za odabir datoteka",
  "supported-formats": "Podržani formati",
  "existing-documents": "Postojeći dokumenti",
  "documents-uploaded-successfully": "Dokumenti su uspješno učitani",
  "document-deleted-successfully": "Dokument je uspješno izbrisan",
  "no-course-documents-available": "Trenutačno niste prijavljeni ni na jedan tečaj ili dokumenti nisu dostupni.",
  "more-files": "Dodatne datoteke",
  publicProfile: {
    status: {
      valid: "Važeće",
      expiringSoon: "Istječe uskoro",
      expired: "Isteklo",
      certified: "Certificirano",
      open: "Otvoreno",
      none: "Nema",
    },
    jobTitle: {
      efk: "HV-ESP",
      hv0: "HV-IP",
      "hv1-3": "HV-EIP",
    },
    experienceStartDate: "Radno iskustvo od",
    backgroundImage: "Slika pozadine",
    totalCertificatesTitle: "Certifikati",
    totalCertificatesDescription: "Broj svih certifikata",
    trainingLevelTitle: "Razina obuke",
    trainingLevelDescription: "Najviša razina obuke",
    practicalOperationsTitle: "Praktični radovi",
    practicalOperationsDescription: "Praktično iskustvo u radu s HV sustavima",
    vehicleModelsTitle: "Modeli vozila",
    vehicleModelsDescription: "Servisirani modeli HV vozila",
    dashboardTitle: "Pregled iskustva u radu s HV sustavima",
    dashboardSubtitle: "Detaljna statistika i stručnost u području HV sustava",
    certificationsTitle: "Certifikacije",
    certificationsSubtitle: "Pregled obuka i certifikacija u području HV sustava",
    instructor: "Instruktor",
    issuedOn: "Izdano",
    validUntil: "Vrijedi do",
    view: "Prikaži",
    loadMoreCertificates: "Učitaj dodatne certifikate",
    hideCertificates: "Sakrij certifikate",
    nav: {
      certifications: "Certifikacije",
      specialTraining: "Specijalističke obuke",
      practicalExperiences: "Praktična iskustva",
      vehicleCategories: "Kategorije vozila",
    },
    specialTraining: {
      title1: "Specijalističke",
      title2: "obuke",
      subtitle: "Dodatne kvalifikacije i specijalističke obuke",
    },
    practicalExperiences: {
      title1: "Praktična",
      title2: "iskustva",
      subtitle: "Praktično iskustvo u radu s HV sustavima",
      freischaltungen: {
        title: "Odvajanja od napajanja",
        description: "Provedena odvajanja HV sustava od napajanja",
      },
      isolationstests: {
        title: "Mjerenja izolacijskog otpora",
        description: "Provedena mjerenja izolacijskog otpora",
      },
      potentialtests: {
        title: "Izjednačavanje potencijala",
        description: "Provedena mjerenja izjednačavanja potencijala",
      },
      checklists: {
        title: "Dovršene kontrolne liste",
        description: "Dovršene sigurnosne kontrolne liste",
      },
      chargingCableChecks: {
        title: "Ispitivanja kabela za punjenje",
        description: "HV-C certificirane sigurnosne inspekcije kabela",
      },
      issuedCertificates: {
        title: "Izdani certifikati",
        description: "Certifikati izdani u ulozi trenera",
      },
    },
    vehicleCategories: {
      title1: "Kategorije ",
      title2: "vozila",
      subtitle: "Specijaliziran za sljedeće kategorije vozila i primjene",
    },
    gtpCategories: {
      roadVehicles: "Cestovna vozila",
      machines: "Građevinski strojevi",
      racingVehicles: "Trkaća vozila",
      aircraft: "Zrakoplovi",
      watercraft: "Plovila",
      railVehicles: "Željeznička vozila",
      developmentProduction: "Istraživanje i razvoj",
      aftersales: "Poslijeprodajne usluge",
    },
    footer: {
      qrTitle: "Pristup putem QR koda",
      qrSubtitle: "Skenirajte kod za brzi pristup profilu",
      qrHint: "Skeniraj kamerom",
      copyright: "© {year} Evalcard.com – Sva prava pridržana",
      imprint: "Impresum",
      privacy: "Pravila privatnosti",
    },
    shareProfile: "Podijeli profil",
    currentEmployer: "Trenutni poslodavac",
    linkCopied: "Poveznica je uspješno kopirana u međuspremnik",
    evalusProfile: "Evalus profil",
    sharingNotSuccessful: "Dijeljenje nije uspjelo.",
    showInvalidCertificates: "Prikaži istekle certifikate",
    hideInvalidCertificates: "Sakrij istekle certifikate",
    invalidCertificatesHint: "Sakriveni certifikati koji su zamijenjeni novijima",
    evalId: "Eval-ID br.",
    ogCertifications: "Certifikacije",
    ogDescription: "Javni profil na EvalCardu",
  },
  academy: {
    academy: "Akademija",
    administration: "Administracija",
    "my-orders": "Moje narudžbe",
    "manage-courses": "Upravljaj tečajevima",
    data: "Osnovni podaci",
    price: "Cijena",
    "book-for-me": "Rezerviraj za sebe",
    "book-for-employee": "Rezerviraj za zaposlenike",
    passing_score: "Prag prolaznosti (%)",
    max_exam_attempts: "Najveći broj pokušaja polaganja ispita",
    max_exam_attempts_hint: "0 = neograničeno",
    exam_attempts_remaining: "Preostali pokušaji: {remaining} od {max}",
    exam_attempts_used: "Pokušaji: {used}",
    exam_attempts_limit_reached: "Dosegnut je najveći broj pokušaja polaganja ispita",
    "edit-course": "@:edit-course",
    "all-languages-have-content": "Sadržaj tečaja već postoji na svim jezicima.",
    "must-be-company-member-to-book": "Morate biti član tvrtke da biste mogli rezervirati tečajeve.",
  },
  course: {
    course: "Tečaj",
    courses: "Tečajevi",
    "my-courses": "Moji tečajevi",
    "my-courses-view": "Pregled tečaja",
    content: "Sadržaj tečaja",
    "edit-content": "Uredi sadržaj tečaja",
    learn: "Učenje",
    "learn-trail": "Putanja učenja",
    exam: "Ispit",
    "exam-trail": "Ispitna putanja",
    section: "Odjeljak",
    addLearnSection: "Dodaj odjeljak za učenje",
    addLearnTask: "Dodaj zadatak za učenje",
    addExamSection: "Dodaj ispitni odjeljak",
    addExamTask: "Dodaj ispitno pitanje",
    sectionTitle: "Naslov odjeljka",
    taskTitle: "Naslov zadatka",
    questionTitle: "Naslov pitanja",
    enterSectionTitle: "Unesite naslov odjeljka...",
    enterTaskTitle: "Unesite naslov zadatka...",
    enterQuestionTitle: "Unesite naslov pitanja...",
    titleRequired: "Naslov je obavezan",
    titleTooShort: "Naslov mora imati najmanje 2 znaka",
    itemAddedSuccessfully: "Element je uspješno dodan",
    errorAddingItem: "Pogreška pri dodavanju elementa",
    selectItemFromSidebar: "Odaberite element iz bočne trake",
    task: "Zadatak",
    question: "Pitanje",
    enterTitle: "Unesite naslov...",
    addItem: "Dodaj element",
    "purchase-course": "Kupi tečaj",
    "purchase-initiated": "Kupnja je uspješno pokrenuta",
    "learning-objectives": "Ciljevi učenja",
    prerequisites: "Preduvjeti",
    syllabus: "Nastavni plan tečaja",
    "learn-section": "Odjeljak za učenje",
    "exam-section": "Ispitni odjeljak",
    free: "Besplatno",
    booking: "Rezervacija",
    "purchase-date": "Rezervirano dana",
    question_type: {
      question_type: "Vrsta pitanja",
      multiple_choice: "Višestruki izbor",
      number: "Broj",
      yes_no: "Da / Ne",
    },
    operator: {
      operator: "Operator",
      equals: "Jednako",
      notEquals: "Nije jednako",
      greaterThan: "Veće od",
      lessThan: "Manje od",
      greaterThanOrEqual: "Veće ili jednako",
      lessThanOrEqual: "Manje ili jednako",
    },
    correct_answer: "Točan odgovor",
    yes: "Da",
    no: "Ne",
    answer: "Odgovor",
    unit: "Jedinica",
    select_course: "Odaberi tečaj",
    select_language: "Odaberi jezik tečaja",
    select_users: "Odaberi korisnike",
    error: {
      publish: "Pogreška pri objavi tečaja",
      course_content_required: "Tečaj mora imati barem jedan sadržaj",
      certification_authority_required: "Potrebno je najmanje jedno certifikacijsko tijelo",
      certificate_template_missing: "Za svaki sadržaj tečaja potrebno je odabrati predložak certifikata za svako certifikacijsko tijelo.",
      learn_section_task_required: "Svaki odjeljak za učenje mora sadržavati barem jedan zadatak",
      exam_section_task_required: "Svaki ispitni odjeljak mora sadržavati barem jedno ispitno pitanje",
      monetization_required: "Tečaj mora biti označen kao besplatan ili mu mora biti dodijeljen Paddle proizvod",
    },
    finish_course: "Dovrši tečaj",
    completed_message: "Uspješno ste dovršili ovaj tečaj.",
    linked_exam_section: "Povezani ispitni odjeljak",
    linked_exam_section_hint: "Nakon dovršetka ovog odjeljka za učenje prikazat će se povezani ispitni odjeljak.",
    inline_exam_section: "Ispitna pitanja",
    inline_exam_section_info: "Odgovorite na sva pitanja kako biste nastavili. Vaši odgovori su konačni.",
    question_progress: "Pitanje {current} od {total}",
    complete_exam_section: "Dovrši odjeljak",
    answered_during_learning: "Odgovoreno tijekom učenja",
    section_already_answered: "Na pitanja u ovom odjeljku već je odgovoreno",
    answers_are_final: "Odgovori se više ne mogu mijenjati",
  },
  enrollment: {
    status: {
      in_progress: "Započeto",
      not_started: "Nije započeto",
      completed: "Dovršeno",
    },
    enrolled_courses: "Tečajevi na koje ste upisani",
    enroll_course: "Upiši na tečaj",
    enrolled_on: "Upisano dana",
  },
  order: {
    order: "Narudžba | Narudžbe",
    my_orders: "Moje narudžbe",
    view_order: "Prikaži",
    ordered_at: "Datum narudžbe",
    status: {
      paid: "Plaćeno",
      pending: "Na čekanju",
      failed: "Nije uspjelo",
      refunded: "Novac vraćen",
      cancelled: "Otkazano",
    },
    payment: {
      paddle: "Paddle",
      request: "Upit",
      none: "Nema",
    },
    payment_method: "Način plaćanja",
    purchased_by: "Kupio",
    purchased_for: "Kupljeno za",
    product: "Proizvod",
    "page-title": "Narudžba",
    thank_you: "Hvala Vam na kupnji!",
    no_transaction_headline: "Narudžba nije pronađena",
    no_transaction_text: "Ova narudžba ne postoji ili je došlo do pogreške.",
    back_to_courses: "Natrag na tečajeve",
    go_to_my_courses: "Na moje tečajeve",
    purchase_now: "Kupi sada",
    payment_pending: "Čeka se plaćanje",
    payment_pending_text: "Vaša je narudžba primljena, ali plaćanje još nije dovršeno. Dovršite plaćanje kako biste pristupili svom tečaju.",
    cancel_success: "Narudžba je uspješno otkazana",
    cancel_error: "Pogreška pri otkazivanju narudžbe",
  },
  language: "Jezik",
  short_description: "Kratki opis",
  progress: "Napredak",
  total: "Ukupno",
  complete_section: "Dovrši odjeljak",
  mark_task_complete: "Označi zadatak kao dovršen",
  video_not_supported: "Vaš preglednik ne podržava videoelement.",
  overall_progress: "Ukupan napredak",
  section_progress: "Napredak odjeljka",
  task_completed: "Zadatak je uspješno dovršen",
  section_completed: "Odjeljak je uspješno dovršen",
  error_completing_task: "Pogreška pri dovršavanju zadatka",
  error_completing_section: "Pogreška pri dovršavanju odjeljka",
  next: "Nastavi",
  finish_learning: "Završi učenje",
  start_learning: "Pokreni učenje",
  continue_learning: "Nastavi učenje",
  take_exam_attempt: "Pokreni ispit",
  copy_course: "Kopiraj tečaj",
  select: "Odaberi",
  exam_results: {
    congratulations: "Srdačne čestitke!",
    not_passed: "Nije položeno",
    score: "Broj bodova",
    you_passed: "Uspješno ste položili ispit!",
    need_score_to_pass: "Za prolaz je potrebno ostvariti rezultat {score}. Pokušajte ponovno.",
    score_details: "Pojedinosti o bodovima",
    question: "Pitanje",
    back_to_course: "Natrag na tečaj",
    retake_exam: "Ponovi ispit",
    view_certificate: "Prikaži certifikat",
    download_certificate: "Preuzmi certifikat",
  },
  exam_export: {
    export_pdf: "Izvezi kao PDF",
    title: "Rezultat ispita",
    participant: "Polaznik",
    birthday: "Datum rođenja",
    course: "Tečaj",
    attempt_number: "Pokušaj",
    started_at: "Započeto dana",
    finished_at: "Dovršeno dana",
    overall_score: "Ukupan rezultat",
    passed: "Položeno",
    failed: "Nije položeno",
    given_answer: "Uneseni odgovor",
    correct_answer: "Točan odgovor",
    no_answer: "Nema odgovora",
    yes: "Da",
    no: "Ne",
    select_attempt: "Odaberi pokušaj",
    no_attempts: "Nema dovršenih pokušaja",
    no_exam: "Ovaj tečaj nema ispit",
    generating: "PDF se izrađuje …",
    export_failed: "Izvoz nije uspio",
  },
  "academy-assignment": {
    title: "Dodijeljeni tečajevi akademije",
    "academy-course": "Tečaj akademije",
    "available-for-regular-courses": "Može se odabrati za redovne tečajeve",
    "for-regular-courses-badge": "Za redovne tečajeve",
    "cannot-publish-regular-course": "Ovaj se tečaj ne može objaviti jer je namijenjen redovnim tečajevima.",
    language: "Jezik",
    "select-course-first": "Najprije odaberite tečaj akademije",
    "no-matching-courses": "Nema dostupnih odgovarajućih tečajeva akademije (neobjavljenih, omogućenih i odgovarajuće razine)",
    type: "Vrsta",
    "type-entry": "Ulazni test",
    "type-intermediate": "Provjera znanja tijekom tečaja",
    "type-final": "Završni ispit",
    assign: "Dodijeli tečaj akademije",
    remove: "Ukloni dodjelu",
    "remove-warning": "Uklanjanjem dodjele izbrisat će se upisi polaznika i njihovi rezultati ispita za ovaj tečaj akademije. Želite li nastaviti?",
    "assigned-successfully": "Tečaj akademije je uspješno dodijeljen",
    "removed-successfully": "Dodjela je uspješno uklonjena",
    results: "Rezultati polaznika",
    participant: "Polaznik",
    score: "Rezultat",
    status: "Status",
    attempts: "Pokušaj",
    passed: "Položeno",
    failed: "Nije položeno",
    "in-progress": "U tijeku",
    "not-started": "Nije započeto",
  },
  exam_interface: {
    sections: "Odjeljci",
    overall_progress: "Ukupan napredak",
    questions: "Pitanja",
    progress: "Napredak",
    section: "Odjeljak",
    question_of: "Pitanje {current} od {total}",
    answered: "Odgovoreno",
    not_answered: "Nije odgovoreno",
    previous: "Natrag",
    next: "Sljedeće",
    submit_exam: "Predaj ispit",
    quick_navigation: "Brza navigacija",
    submit_exam_confirm: "Predati ispit?",
    submit_exam_message: "Jeste li sigurni da želite predati svoj ispit?",
    answered_count: "Odgovorili ste na <strong>{answered}</strong> od <strong>{total}</strong> pitanja.",
    cannot_change_warning: "Nakon predaje svoje odgovore više ne možete mijenjati.",
    loading: "Učitavanje",
    error: "Pogreška",
    back: "Natrag",
    select_certificate_authority: "Odaberi certifikacijsko tijelo",
    select_authority_message: "Odaberite certifikacijsko tijelo za izdavanje Vašeg certifikata.",
    no_authorities_available: "Za ovaj tečaj nisu dostupna certifikacijska tijela.",
    certificate_issued: "Certifikat je uspješno izdan!",
    error_issuing_certificate: "Pogreška pri izdavanju certifikata",
    exam_submitted_successfully: "Ispit je uspješno predan!",
    exam_submit_error: "Pogreška pri predaji ispita",
  },
  could_not_add_section: "Odjeljak nije bilo moguće dodati",
  successfully_added_section: "Odjeljak je uspješno dodan",
  could_not_add_task: "Zadatak nije bilo moguće dodati",
  successfully_added_task: "Zadatak je uspješno dodan",
  could_not_remove_attachment: "Prilog nije bilo moguće ukloniti",
  successfully_removed_attachment: "Prilog je uspješno uklonjen",
  could_not_remove_task: "Zadatak nije bilo moguće ukloniti",
  successfully_removed_task: "Zadatak je uspješno uklonjen",
  could_not_remove_section: "Odjeljak nije bilo moguće ukloniti",
  successfully_removed_section: "Odjeljak je uspješno uklonjen",
  "default-academy-issuer": "Zadani izdavatelj certifikata akademije",
  "default-academy-issuer-hint": "Automatski izdaje certifikate za završene tečajeve akademije, osim ako polaznik već ima certifikat drugog tijela dodijeljenog tečaju. Samo jedno tijelo može biti zadano.",
  "academy-documents": "Dokumenti akademije",
  "back-to-documents": "Natrag na moje dokumente",
  "completed-on": "Dovršeno dana",
  "my-documents-academy": "Moji dokumenti akademije",
  "from-task": "Iz zadatka",
  "from-section": "Iz odjeljka",
  "no-documents-in-course": "Nema dostupnih dokumenata u ovom tečaju",
  "unknown-course": "Nepoznat tečaj",
  "error-loading-documents": "Pogreška pri učitavanju dokumenata",
}
